import { Root } from "../pages-content/auth/component"

export default Root
